import { createAction } from '@reduxjs/toolkit';

import { PropertyData } from '@aloft/toolkit-shared';
import { EditPropertyDetailsFormOutput } from '../../../components/CraftsmanEditPropertyDetailsModal/internal/types.ts';

export const submitEditPropertyDetailsForm = createAction<
  EditPropertyDetailsFormOutput & { id: string; newAutofilledData?: PropertyData }
>('submitEditPropertyDetailsForm');
